let d = new Date();
let year = d.getFullYear();

// 获取注册内容弹窗组件
export function getfreshgraduateDialogData() {
    return [
        {
            key: "stuNum",
            name: "考生号",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'
        },
        {
            key: "name",
            name: "姓名",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'


        }, {
            key: "sex",
            name: "性别",
            value: '男',
            type: 'radio',
            isNull: false,
            writeOrRead: 'write'


        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'


        }, {
            key: "readyProfession",
            name: "考生志愿",
            value: '',
            type: 'select',
            options: [],
            isNull: false,
            writeOrRead: 'write'

        },
        {
            key: "school",
            name: "毕业院校",
            value: '',
            type: 'input',
            isNull: false,
            prompt: "(注:需填写学校全称)",
            writeOrRead: 'write'

        }, {
            key: "profession",
            name: "毕业专业",
            value: '',
            type: 'input',
            isNull: false,
            prompt: "(注:需填写专业全称)",
            writeOrRead: 'write'

        },
        {
            key: "phone",
            name: "联系电话",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        },
        {
            key: "contact",
            name: "紧急联系人",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        },
        {
            key: "address",
            name: "家庭地址",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "statusCheckFile",
            name: "学籍资料审核表",
            fileName: '',
            uploadTitle: "学籍资料审核表",
            type: 'uploadImg2',
            imgFlag: '',
            isNull: false,
            prompt: "(注:须加盖公章后上传)",
            value: [],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'write'

        },
        {
            key: "special",
            name: "鼓励政策/加分政策",
            fileName: '',
            type: 'radios',
            isNull: false,
            // isTip: "指南",
            fujianload: '点击下载 :',
            url: "", // 附件url
            value: "无",
            options:[
                {label:"免试入学",value:"免试入学"},
                {label:"免试面试",value:"免试面试"},
                {label:"加分",value:"加分"},
                {label:"无",value:"无"},
            ],
            fujianName: "",
            nameflag: false,
            writeOrRead: 'write',
            prompt: ""
        }, 
        {
            key: "withoutTestFile",
            name: "加分(免试)",
            fileName: '',
            uploadTitle: "加分(免试)",
            type: 'uploadImg3',
            isNull: true,
            // isTip: "指南",
            fujianload: '点击下载 :',
            url: "", // 附件url
            value: [],
            fujianName: "",
            nameflag: false,
            writeOrRead: 'write',
            prompt: "（最多上传两张）"

        }, {

            key: "proveFile",
            name: "证明材料",
            fileName: '',
            uploadTitle: "证明材料",
            type: 'uploadImg3',
            isNull: false,
            // isTip: "指南",
            fujianload: '',
            url: "", // 附件url
            value: [],
            fujianName: "",
            nameflag: false,
            writeOrRead: 'write',
            prompt: "（注：按照合肥城市学院" + year + "年面向中职毕业生对口招生章程要求提供相关资料）"
        },
    ]
}

//查看
export function showfreshgraduateDialogData() {
    return [
{
            key: "stuNum",
            name: "考生号",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "name",
            name: "姓名",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "sex",
            name: "性别",
            value: '男',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "readyProfession",
            name: "考生志愿",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },{
            key: "school",
            name: "毕业院校",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "profession",
            name: "毕业专业",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "phone",
            name: "联系电话",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },  
        {
            key: "contact",
            name: "紧急联系人",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },  {
            key: "address",
            name: "家庭地址",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },  {
            key: "statusCheckFile",
            name: "学籍资料审核表",
            fileName: '',
            uploadTitle: "学籍资料审核表",
            type: 'imgOrPdf',
            imgFlag: '',
            isNull: true,
            prompt: "(注:须加盖公章后上传)",
            value: [],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'read'
        }, {
            key: "special",
            name: "鼓励政策/加分政策",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, 
        {
            key: "withoutTestFile",
            name: "加分(免试)",
            fileName: '',
            uploadTitle: "加分(免试)",
            type: 'imgOrPdf',
            imgFlag: '',
            isNull: true,
            prompt: "",
            value: [],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'read',
            prompt: "（最多上传两张）"
        },
        {
            key: "proveFile",
            name: "证明材料",
            fileName: '',
            uploadTitle: "证明材料",
            type: 'imgOrPdf',
            imgFlag: '',
            isNull: true,
            prompt: "",
            value: [],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'read',
            prompt: "（注：按照合肥城市学院" + year + "年面向中职毕业生对口招生章程要求提供相关资料）"
        },
    ]
}
